import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {LoggingService} from './logging.service';
import {NavigationService} from '../../shared/utils/navigation.service';
import {APP_ROUTES} from '../../route-constants';
import {environment} from '../../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private readonly injector: Injector) {
    }

    handleError(error: any): void {
        const loggingService = this.injector.get(LoggingService);
        const nav = this.injector.get(NavigationService);
        const fehlerId = error?.error?.['fehler_id'];

        // Log error
        loggingService.error(error);

        // Handle HTTP errors
        if (error instanceof HttpErrorResponse) {
            const status = error.status;

            if (status === 403) {
                if (fehlerId === 'FFP_1009') {
                    console.warn('403 Forbidden - redirecting to forbidden-betriebe page');
                    nav.goTo('/' + APP_ROUTES.FORBIDDEN_BETRIEBE);
                } else {
                    console.warn('403 Forbidden - redirecting to access-denied page');
                    nav.goTo('/' + APP_ROUTES.ACCESS_DENIED);
                }
                return;
            } else if (status === 503) {
                console.warn('503 Service Unavailable');
                this.redirectToMaintenance();
                return;
            } else { // handle all other  HTTP errors thrown which are not handled in specific service
                console.error(`HTTP Error (${status}):`, error.message);
                nav.goTo('/' + APP_ROUTES.ERROR);
                return;
            }
        }

        // Handle client errors (runtime, logic, etc.)
        if (error instanceof Error) {
            console.error('Client Error:', error.message);
            nav.goTo('/' + APP_ROUTES.ERROR);
            return;
        }

        // Fallback
        console.error('Unhandled error:', error);
    }

    protected redirectToMaintenance(): void {
        globalThis.location.href = environment.maintenanceUrl;
    }
}